export default "__VITE_ASSET__CydEekED__"